import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { loadForteForCurrentEnv } from "./utils/loadForteScript";

// Global error handlers for debugging
window.addEventListener('unhandledrejection', event => {
  // Ignore undefined promise rejections from redux-persist (known benign issue)
  if (event.reason === undefined) {
    console.warn('[Global] Suppressed undefined promise rejection (likely from redux-persist)');
    event.preventDefault(); // Prevent the error from appearing in console
    return;
  }

  console.error('[Global] Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise,
    type: typeof event.reason,
    stack: event.reason?.stack
  });
});

window.addEventListener('error', event => {
  console.error('[Global] Uncaught error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

// Ensure Forte scripts load according to environment (sandbox in dev, prod in production)
loadForteForCurrentEnv();

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
